import "./OnceOfHouseCleaning.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import SEO from "../SEO/SEO";
import heroImage from "../Assets/Services/Adelaide-banner-img.png";
import onceOffImg from "../Assets/HouseCleaning/Once-off-Cleaning.png";
import regularCleaningImg from "../Assets/HouseCleaning/Regular-house-cleaning.png";
import leaseCleaningImg from "../Assets/HouseCleaning/End-of-Lease-Cleaning.png";
import getaquote from "../Assets/get_a_quote.jpg";
import { Link } from "react-router-dom";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";
import React, { useState, useEffect, useRef } from "react";
import api, { PUBLIC_BASE_URL, BASE_URL } from "../Api/api";
import trueicon from "../Assets/HouseCleaning/true-icon.png";
import SubFaqPage from "../SubServices/SubFaqPage";
import SuburbsSection from "../Services/SuburbsSection";

const faqData = [
  {
    question: "What house cleaning services does Shiny Cleaning offer?",
    answer:
      "Shiny Cleaning offers a comprehensive range of house cleaning services to meet your needs. Our services include regular cleaning, deep cleaning, vacate cleaning, once-off cleaning, customized cleaning, move-in/out cleaning, post-construction cleaning, and more.",
  },
  {
    question: "How often should I schedule house cleaning with Shiny Cleaning",
    answer:
      "The frequency of house cleaning depends on your preferences and property size. We offer flexible scheduling options, including weekly, fortnightly, monthly, or one-time cleanings, to accommodate your needs.",
  },
  {
    question:
      "Can I request specific cleaning tasks to be included in my house cleaning service?",
    answer:
      "Absolutely! Yes, At Shiny Cleaning, we understand that every home is unique. You can customize your house cleaning service by requesting specific tasks or areas to be cleaned, such as bathrooms, kitchens, bedrooms, or common areas, windows, oven and more.",
  },
  {
    question:
      "Do I need to provide cleaning supplies and equipment for the house cleaning service?",
    answer:
      "No, you don’t need to worry about providing cleaning supplies or equipment. Shiny Cleaning brings all the necessary supplies and equipment needed to clean your home efficiently and effectively.",
  },
  {
    question: "Can we leave you a key?",
    answer:
      "At booking with Shiny Cleaning a regular service, we endeavour to send the same team every time. That team is responsible for handling and storing keys in a safe and secure location. We are responsible for lost keys and replacement of locks should it be necessary.",
  },
  {
    question: "How do I schedule a house cleaning service with Shiny Cleaning?",
    answer:
      "Scheduling a house cleaning service with Shiny Cleaning is easy! Simply visit our website at www.shinycleaner.com to book online or give us a call at 0406 958 557. We’ll work with you to find a convenient time for your cleaning service.",
  },
  {
    question: "Are the cleaners from Shiny Cleaning trained and experienced?",
    answer:
      "Yes, all cleaners at Shiny Cleaning are highly trained professionals with extensive experience in house cleaning. They undergo rigorous training to ensure they meet our high standards. Our cleaners are insured and have national crime checks.",
  },
  {
    question: "Will the same cleaners come to clean my house each time?",
    answer:
      "We strive to provide consistency and build trust with our clients. While we cannot guarantee the same cleaners for every service, we make every effort to assign familiar faces whenever possible.",
  },
  {
    question:
      "What safety measures does Shiny Cleaning have in place during house cleaning?",
    answer:
      "Shiny Cleaning prioritizes safety. Our cleaners follow strict protocols including wearing masks and gloves, practicing social distancing, and using eco-friendly cleaning products.",
  },
  {
    question: "What if I’m not satisfied with the house cleaning service?",
    answer:
      "Your satisfaction is our top priority. If you’re not happy with any aspect of the service, please fill out the contact form at www.shinycleaner.com or call 0406 958 557. We’ll make it right. We offer a satisfaction guarantee.",
  },
];

const OnceOffHouseCleaning = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const [item, setItem] = useState(null);

  useEffect(() => {
    api.get(`/whychoosehousecleaningservice/view/11`).then((res) => {
      setItem(res.data);
    });
  }, []);

  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get("/sub-services-after-hero/1") // change ID if needed
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  }, []);

  // Fetch slider content from API
  const [sliderData, setSliderData] = useState({
    headline: "Once Off House Cleaning Service",
    subtext: "",
  });

  useEffect(() => {
    api
      .get("service-slider/once-off-house-cleaning")
      .then((res) => {
        if (res.data) {
          setSliderData({
            headline: res.data.headline,
            subtext: res.data.subtext,
          });
        }
      })
      .catch((err) => console.error("Slider Fetch Error", err));
  }, []);

  return (
    <>
      <SEO />
      <Header />

      <section
        className="hero-section py-5 text-white text-center"
        style={{
          background: `url(${heroImage}) center/cover`,
        }}
      >
        <div className="container" style={{ marginTop: "100px" }}>
          <h1 className="display-5 fw-bold">{sliderData.headline || "Once Off House Cleaning Service"}</h1>

          {sliderData.subtext && (
            <p className="lead mb-4 px-4" style={{ maxWidth: "800px", margin: "0 auto 20px" }}>
              {sliderData.subtext}
            </p>
          )}

          <span>
            Home
            <Link
              to="/service/house-cleaning/"
              className="text-decoration-none text-white"
            >
              / Services
            </Link>
          </span>

          <div className="quote-buttons d-flex flex-column flex-md-row justify-content-center gap-3 mt-5">
            <Link
              to="/free-quote"
              className="btn btn-danger d-inline-flex align-items-center gap-2"
            >
              Get Free Quote <FaArrowRight />
            </Link>
            <Link
              to="tel:0406958557"
              className="btn btn-primary d-inline-flex align-items-center gap-2"
            >
              Call Now <FaPhoneAlt />
            </Link>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container">
          <div className="row align-items-center gy-5">
            {/* Image Section */}
            <div className="col-lg-6">
              <div className="position-relative overflow-hidden rounded-4 shadow blog-img-wrapper">
                <img
                  src={`${PUBLIC_BASE_URL}${data?.image}`}
                  alt={data?.heading}
                  className="img-fluid w-100 rounded-4 object-fit-cover"
                  style={{ minHeight: "300px" }}
                />
              </div>
            </div>

            {/* Content Section */}
            <div className="col-lg-6">
              <div className="p-4 bg-white bg-opacity-75 shadow-lg rounded-4 animate-fade">
                <h2 className="fw-bold mb-3" style={{ color: "#001070" }}>
                  {data?.heading}
                </h2>
                {data?.description.split("\n").map((line, idx) => (
                  <p key={idx} className="text" style={{ color: "#2B2B2B" }}>
                    {line}
                  </p>
                ))}
                <div className="d-flex gap-3 mt-4 flex-wrap">
                  <Link
                    to="/free-quote"
                    className="btn btn-danger px-4 py-2 fw-semibold"
                  >
                    Get Free Quote
                  </Link>
                  <Link
                    to="/contact-us"
                    className="btn btn-primary px-4 py-2 fw-semibold"
                  >
                    Call Now <i className="bi bi-telephone-fill"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-options">
        <div className="container">
          <h2>Why Invest in One Off House Cleaning?</h2>

          <div className="services-grid">
            {/* Card 1 */}
            <div className="service-card">
              <i>
                <img
                  src={onceOffImg}
                  alt="Once-off-Cleaning"
                  style={{ width: "60px" }}
                />
              </i>
              <h3>Health and Safety</h3>
              <p>
                Our prioritize a clean and hygienic home environment, especially
                in light of health concerns, so our clients appreciate once
                cleaning services that prioritize health and safety protocols.
              </p>
            </div>

            {/* Card 2 */}
            <div className="service-card">
              <i>
                <img
                  src={regularCleaningImg}
                  alt="Regular-house-cleaning"
                  style={{ width: "60px" }}
                />
              </i>
              <h3>Convenience</h3>
              <p>
                Ultimately, our clients value the convenience of having a
                professional cleaning service take care of the hard work,
                allowing them to enjoy a clean and comfortable home without the
                hassle of cleaning themselves.
              </p>
            </div>

            {/* Card 3 */}
            <div className="service-card">
              <i>
                <img
                  src={leaseCleaningImg}
                  alt="End-of-Lease-Cleaning"
                  style={{ width: "60px" }}
                />
              </i>
              <h3>Satisfaction Guarantee</h3>
              <p>
                Knowing that the Shiny cleaning stands behind their work with a
                satisfaction guarantee gives customers peace of mind and
                confidence in the service.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose py-5">
        <div className="why-container container d-flex flex-column flex-lg-row align-items-center justify-content-between">
          <div className="why-text mb-4 mb-lg-0">
            <h2 className="fw-bold mb-4">
              {item?.heading.split(" ").slice(0, -3).join(" ")}{" "}
              <span>{item?.heading.split(" ").slice(-3).join(" ")}</span>
            </h2>
            <ul className="list-unstyled">
              {item?.points.map((point, index) => (
                <li className="mb-3 d-flex align-items-start" key={index}>
                  <img src={trueicon} alt="check" className="me-2 icon" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="why-image text-center">
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">
              <div>
                <img
                  src={`${PUBLIC_BASE_URL}${item?.before_image}`}
                  alt="Before"
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: "300px" }}
                />
                <div className="caption fw-bold mt-2">Before</div>
              </div>

              <div className="fw-bold display-5 mx-2 d-none d-md-block">→</div>

              <div>
                <img
                  src={`${PUBLIC_BASE_URL}${item?.after_image}`}
                  alt="After"
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: "300px" }}
                />
                <div className="caption fw-bold mt-2">After</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SubFaqPage id="Once Off House Cleaning Service" />

      <SuburbsSection />

      <section className="quote-section pt-5">
        <div className="row">
          <div className="col-md-6">
            <div className="quote-container container text-center">
              <h2 className=" fw-bold mb-3">
                Book Your Once-Off House Cleaning Service
              </h2>
              <p className="mb-4 text-muted mt-5">
                Shiny Cleaning makes it easy to get your home deep cleaned — no
                contracts, no stress. Enjoy affordable, reliable house cleaning
                service in Adelaide & Melbourne with just one booking. <br />
                📞 Call now or request a free quote online — and leave the
                cleaning to us!
              </p>

              <div className="quote-buttons d-flex flex-column flex-md-row justify-content-center gap-3 mt-5">
                <Link
                  to="/free-quote"
                  className="btn btn-outline-info d-inline-flex align-items-center gap-2 "
                >
                  Get Free Quote <FaArrowRight />
                </Link>
                <Link
                  to="tel:0406958557"
                  className="btn btn-outline-primary d-inline-flex align-items-center gap-2"
                >
                  Call Now <FaPhoneAlt />
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-6 px-5">
            <img src={getaquote} className="h-75 w-75" />
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default OnceOffHouseCleaning;
